import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ConsumableCard = ({ consumable, onEdit, onRestock, onViewHistory, onDelete }) => {
  const stockPercentage = (consumable?.current_stock / consumable?.minimum_threshold) * 100;
  const isLowStock = consumable?.current_stock <= consumable?.minimum_threshold;
  const isOutOfStock = consumable?.current_stock === 0;

  const getStockStatusColor = () => {
    if (isOutOfStock) return 'text-error';
    if (isLowStock) return 'text-warning';
    return 'text-success';
  };

  const getStockStatusBg = () => {
    if (isOutOfStock) return 'bg-error/10 border-error/20';
    if (isLowStock) return 'bg-warning/10 border-warning/20';
    return 'bg-success/10 border-success/20';
  };

  const unitLabels = {
    piece: 'pièce(s)',
    meter: 'mètre(s)',
    liter: 'litre(s)',
    kilogram: 'kg',
    box: 'boîte(s)',
    roll: 'rouleau(x)',
    tube: 'tube(s)',
    cartridge: 'cartouche(s)',
    bottle: 'bouteille(s)'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-1">{consumable?.name}</h3>
          {consumable?.reference_code && (
            <p className="text-xs text-muted-foreground">Réf: {consumable?.reference_code}</p>
          )}
        </div>
        <div className={`px-2 py-1 rounded text-xs font-medium ${getStockStatusBg()} ${getStockStatusColor()}`}>
          {isOutOfStock ? 'Rupture' : isLowStock ? 'Stock faible' : 'OK'}
        </div>
      </div>
      {consumable?.description && (
        <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{consumable?.description}</p>
      )}
      <div className="space-y-2 mb-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Stock actuel</span>
          <span className={`font-semibold ${getStockStatusColor()}`}>
            {consumable?.current_stock} {unitLabels?.[consumable?.unit] || consumable?.unit}
          </span>
        </div>
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">Seuil minimum</span>
          <span className="font-medium text-foreground">
            {consumable?.minimum_threshold} {unitLabels?.[consumable?.unit] || consumable?.unit}
          </span>
        </div>
        {consumable?.unit_price && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Prix unitaire</span>
            <span className="font-medium text-foreground">{consumable?.unit_price?.toFixed(2)}€</span>
          </div>
        )}
        {consumable?.suppliers?.name && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">Fournisseur</span>
            <span className="font-medium text-foreground">{consumable?.suppliers?.name}</span>
          </div>
        )}
      </div>
      <div className="w-full bg-muted rounded-full h-2 mb-4">
        <div
          className={`h-2 rounded-full transition-all ${
            isOutOfStock ? 'bg-error' : isLowStock ? 'bg-warning' : 'bg-success'
          }`}
          style={{ width: `${Math.min(stockPercentage, 100)}%` }}
        />
      </div>
      <div className="flex gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Plus"
          onClick={onRestock}
          className="flex-1"
        >
          Réappro
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="History"
          onClick={onViewHistory}
        >
          <Icon name="History" size={16} />
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          onClick={onEdit}
        >
          <Icon name="Edit" size={16} />
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Trash2"
          onClick={onDelete}
        >
          <Icon name="Trash2" size={16} />
        </Button>
      </div>
    </div>
  );
};

export default ConsumableCard;